export default "__VITE_ASSET__Bym4qa6$__"